import axios, { AxiosInstance } from 'axios';
import { tokenInterceptor, xsrfInterceptor, sessionExpiredInterceptor } from './HttpInterceptors';

export type HttpClient = AxiosInstance;

export function createHttpClient() {
  const instance = axios.create();

  if (process.env.NODE_ENV === "production") {
    instance.interceptors.request.use(xsrfInterceptor);
  } else {
    instance.interceptors.request.use(tokenInterceptor);
  }

  instance.interceptors.response.use(
    undefined, sessionExpiredInterceptor
  );

  return instance;
}

const httpClient = createHttpClient();

export default httpClient;